<template>
  <div class="page-wrapper">
    <div class="page-head">
      <h1>{{ $vuetify.lang.t('$vuetify.menu.garage') }}</h1>

      <div class="page-head__buttons">
        <button class="btn-secondary btn" @click="arch = !arch; page=1">
          <span v-if="!arch">{{ $vuetify.lang.t('$vuetify.archive') }}</span>
          <span v-else>{{ $vuetify.lang.t('$vuetify.outArchive') }}</span>
        </button>
        <button v-if="permissions.edit.indexOf('Гараж') != -1" class="btn-secondary btn"
                @click="car_action='add'; car_create_open()">
          + {{ $vuetify.lang.t('$vuetify.add') }}
        </button>
      </div>
    </div>

    <div class="page-head page-head--sorts">
      <div class="page__sorts">
        <v-text-field class="search-field" v-model="search" @keypress.enter="page=1; loadData()"
                      :placeholder="$vuetify.lang.t('$vuetify.sorts.searchCar')" outlined
                      prepend-inner-icon="$search" hide-details>
        </v-text-field>
        <v-select class="sorts__select show" v-model="filter"
                  :label="$vuetify.lang.t('$vuetify.filter')"
                  :items="selectFilter" item-text="name" item-value="value" @change="loadData"
                  :menu-props="{
                                      bottom: true,
                                      offsetY: true,
                                      maxHeight: 200,
                                      contentClass: 'select-menu select-menu--sort',
                                  }" outlined hide-details attach></v-select>
        <v-select class="sorts__select" :class="{ show: type == 'cards' }" v-model="sort"
                  :label="$vuetify.lang.t('$vuetify.dataTable.sortBy')"
                  :items="selectSorts" item-text="name" item-value="value"
                  :menu-props="{
                                      bottom: true,
                                      offsetY: true,
                                      maxHeight: 200,
                                      contentClass: 'select-menu select-menu--sort',
                                  }" outlined hide-details attach></v-select>
      </div>
      <div class="page-head--right">
        <per-page-select v-model="perPage"></per-page-select>
        <div class="type-switcher">
          <div class="type-switcher__item" :class="{ show: type == 'rows' }" @click="type = 'rows'">
            <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" y="0.5" width="33" height="33" rx="4.5"/>
              <path
                d="M9.20039 9.7998C8.723 9.7998 8.26516 9.98945 7.9276 10.327C7.59003 10.6646 7.40039 11.1224 7.40039 11.5998V13.9998C7.40039 14.4772 7.59003 14.935 7.9276 15.2726C8.26516 15.6102 8.723 15.7998 9.20039 15.7998H11.6004C12.0778 15.7998 12.5356 15.6102 12.8732 15.2726C13.2107 14.935 13.4004 14.4772 13.4004 13.9998V11.5998C13.4004 11.1224 13.2107 10.6646 12.8732 10.327C12.5356 9.98945 12.0778 9.7998 11.6004 9.7998H9.20039ZM8.60039 11.5998C8.60039 11.4407 8.6636 11.2881 8.77613 11.1755C8.88865 11.063 9.04126 10.9998 9.20039 10.9998H11.6004C11.7595 10.9998 11.9121 11.063 12.0247 11.1755C12.1372 11.2881 12.2004 11.4407 12.2004 11.5998V13.9998C12.2004 14.1589 12.1372 14.3115 12.0247 14.4241C11.9121 14.5366 11.7595 14.5998 11.6004 14.5998H9.20039C9.04126 14.5998 8.88865 14.5366 8.77613 14.4241C8.6636 14.3115 8.60039 14.1589 8.60039 13.9998V11.5998ZM16.4004 10.9998C16.2413 10.9998 16.0886 11.063 15.9761 11.1755C15.8636 11.2881 15.8004 11.4407 15.8004 11.5998C15.8004 11.7589 15.8636 11.9115 15.9761 12.0241C16.0886 12.1366 16.2413 12.1998 16.4004 12.1998H26.0004C26.1595 12.1998 26.3121 12.1366 26.4247 12.0241C26.5372 11.9115 26.6004 11.7589 26.6004 11.5998C26.6004 11.4407 26.5372 11.2881 26.4247 11.1755C26.3121 11.063 26.1595 10.9998 26.0004 10.9998H16.4004ZM16.4004 13.3998C16.2413 13.3998 16.0886 13.463 15.9761 13.5755C15.8636 13.6881 15.8004 13.8407 15.8004 13.9998C15.8004 14.1589 15.8636 14.3115 15.9761 14.4241C16.0886 14.5366 16.2413 14.5998 16.4004 14.5998H23.6004C23.7595 14.5998 23.9121 14.5366 24.0247 14.4241C24.1372 14.3115 24.2004 14.1589 24.2004 13.9998C24.2004 13.8407 24.1372 13.6881 24.0247 13.5755C23.9121 13.463 23.7595 13.3998 23.6004 13.3998H16.4004ZM9.20039 18.1998C8.723 18.1998 8.26516 18.3894 7.9276 18.727C7.59003 19.0646 7.40039 19.5224 7.40039 19.9998V22.3998C7.40039 22.8772 7.59003 23.335 7.9276 23.6726C8.26516 24.0102 8.723 24.1998 9.20039 24.1998H11.6004C12.0778 24.1998 12.5356 24.0102 12.8732 23.6726C13.2107 23.335 13.4004 22.8772 13.4004 22.3998V19.9998C13.4004 19.5224 13.2107 19.0646 12.8732 18.727C12.5356 18.3894 12.0778 18.1998 11.6004 18.1998H9.20039ZM8.60039 19.9998C8.60039 19.8407 8.6636 19.6881 8.77613 19.5755C8.88865 19.463 9.04126 19.3998 9.20039 19.3998H11.6004C11.7595 19.3998 11.9121 19.463 12.0247 19.5755C12.1372 19.6881 12.2004 19.8407 12.2004 19.9998V22.3998C12.2004 22.5589 12.1372 22.7115 12.0247 22.8241C11.9121 22.9366 11.7595 22.9998 11.6004 22.9998H9.20039C9.04126 22.9998 8.88865 22.9366 8.77613 22.8241C8.6636 22.7115 8.60039 22.5589 8.60039 22.3998V19.9998ZM16.4004 19.3998C16.2413 19.3998 16.0886 19.463 15.9761 19.5755C15.8636 19.6881 15.8004 19.8407 15.8004 19.9998C15.8004 20.1589 15.8636 20.3115 15.9761 20.4241C16.0886 20.5366 16.2413 20.5998 16.4004 20.5998H26.0004C26.1595 20.5998 26.3121 20.5366 26.4247 20.4241C26.5372 20.3115 26.6004 20.1589 26.6004 19.9998C26.6004 19.8407 26.5372 19.6881 26.4247 19.5755C26.3121 19.463 26.1595 19.3998 26.0004 19.3998H16.4004ZM16.4004 21.7998C16.2413 21.7998 16.0886 21.863 15.9761 21.9755C15.8636 22.0881 15.8004 22.2407 15.8004 22.3998C15.8004 22.5589 15.8636 22.7115 15.9761 22.8241C16.0886 22.9366 16.2413 22.9998 16.4004 22.9998H23.6004C23.7595 22.9998 23.9121 22.9366 24.0247 22.8241C24.1372 22.7115 24.2004 22.5589 24.2004 22.3998C24.2004 22.2407 24.1372 22.0881 24.0247 21.9755C23.9121 21.863 23.7595 21.7998 23.6004 21.7998H16.4004Z"
                fill="#2A3F57"/>
              <rect x="0.5" y="0.5" width="33" height="33" rx="4.5" stroke="#2A3F57"/>
            </svg>
          </div>
          <div class="type-switcher__item" :class="{ show: type == 'cards' }" @click="type = 'cards'">
            <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M15.5738 8.86902C14.9918 8.3126 14.2024 8 13.3793 8H11.1034C10.2804 8 9.49099 8.3126 8.90898 8.86902C8.32697 9.42545 8 10.1801 8 10.967V13.5385C8 14.3254 8.32697 15.08 8.90898 15.6365C9.49099 16.1929 10.2804 16.5055 11.1034 16.5055H13.3793C14.2024 16.5055 14.9918 16.1929 15.5738 15.6365C16.1558 15.08 16.4828 14.3254 16.4828 13.5385V10.967C16.4828 10.1801 16.1558 9.42545 15.5738 8.86902ZM9.24138 13.5385V10.967C9.24138 10.4949 9.43756 10.0421 9.78677 9.70823C10.136 9.37437 10.6096 9.18681 11.1034 9.18681H13.3793C13.8732 9.18681 14.3468 9.37437 14.696 9.70823C15.0452 10.0421 15.2414 10.4949 15.2414 10.967V13.5385C15.2414 14.0106 15.0452 14.4634 14.696 14.7973C14.3468 15.1311 13.8732 15.3187 13.3793 15.3187H11.1034C10.6096 15.3187 10.136 15.1311 9.78677 14.7973C9.43756 14.4634 9.24138 14.0106 9.24138 13.5385Z"
                    fill="#2A3F57"/>
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M25.091 8.86902C24.509 8.3126 23.7196 8 22.8966 8H20.6207C19.7976 8 19.0082 8.3126 18.4262 8.86902C17.8442 9.42545 17.5172 10.1801 17.5172 10.967V13.5385C17.5172 14.3254 17.8442 15.08 18.4262 15.6365C19.0082 16.1929 19.7976 16.5055 20.6207 16.5055H22.8966C23.7196 16.5055 24.509 16.1929 25.091 15.6365C25.673 15.08 26 14.3254 26 13.5385V10.967C26 10.1801 25.673 9.42545 25.091 8.86902ZM18.7586 13.5385V10.967C18.7586 10.4949 18.9548 10.0421 19.304 9.70823C19.6532 9.37437 20.1268 9.18681 20.6207 9.18681H22.8966C23.3904 9.18681 23.864 9.37437 24.2132 9.70823C24.5624 10.0421 24.7586 10.4949 24.7586 10.967V13.5385C24.7586 14.0106 24.5624 14.4634 24.2132 14.7973C23.864 15.1311 23.3904 15.3187 22.8966 15.3187H20.6207C20.1268 15.3187 19.6532 15.1311 19.304 14.7973C18.9548 14.4634 18.7586 14.0106 18.7586 13.5385Z"
                    fill="#2A3F57"/>
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M15.5738 18.3635C14.9918 17.8071 14.2024 17.4945 13.3793 17.4945H11.1034C10.2804 17.4945 9.49099 17.8071 8.90898 18.3635C8.32697 18.92 8 19.6746 8 20.4615V23.033C8 23.8199 8.32697 24.5745 8.90898 25.131C9.49099 25.6874 10.2804 26 11.1034 26H13.3793C14.2024 26 14.9918 25.6874 15.5738 25.131C16.1558 24.5745 16.4828 23.8199 16.4828 23.033V20.4615C16.4828 19.6746 16.1558 18.92 15.5738 18.3635ZM9.24138 23.033V20.4615C9.24138 19.9894 9.43756 19.5366 9.78677 19.2027C10.136 18.8689 10.6096 18.6813 11.1034 18.6813H13.3793C13.8732 18.6813 14.3468 18.8689 14.696 19.2027C15.0452 19.5366 15.2414 19.9894 15.2414 20.4615V23.033C15.2414 23.5051 15.0452 23.9579 14.696 24.2918C14.3468 24.6256 13.8732 24.8132 13.3793 24.8132H11.1034C10.6096 24.8132 10.136 24.6256 9.78677 24.2918C9.43756 23.9579 9.24138 23.5051 9.24138 23.033Z"
                    fill="#2A3F57"/>
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M25.091 18.3635C24.509 17.8071 23.7196 17.4945 22.8966 17.4945H20.6207C19.7976 17.4945 19.0082 17.8071 18.4262 18.3635C17.8442 18.92 17.5172 19.6746 17.5172 20.4615V23.033C17.5172 23.8199 17.8442 24.5745 18.4262 25.131C19.0082 25.6874 19.7976 26 20.6207 26H22.8966C23.7196 26 24.509 25.6874 25.091 25.131C25.673 24.5745 26 23.8199 26 23.033V20.4615C26 19.6746 25.673 18.92 25.091 18.3635ZM18.7586 23.033V20.4615C18.7586 19.9894 18.9548 19.5366 19.304 19.2027C19.6532 18.8689 20.1268 18.6813 20.6207 18.6813H22.8966C23.3904 18.6813 23.864 18.8689 24.2132 19.2027C24.5624 19.5366 24.7586 19.9894 24.7586 20.4615V23.033C24.7586 23.5051 24.5624 23.9579 24.2132 24.2918C23.864 24.6256 23.3904 24.8132 22.8966 24.8132H20.6207C20.1268 24.8132 19.6532 24.6256 19.304 24.2918C18.9548 23.9579 18.7586 23.5051 18.7586 23.033Z"
                    fill="#2A3F57"/>
              <rect x="0.5" y="0.5" width="33" height="33" rx="4.5" stroke="#2A3F57"/>
            </svg>
          </div>
          <div class="type-switcher__item type-switcher__item--settings" @click="settingsModal=true">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="path-1-inside-1_1733_6915" fill="white">
                <path
                  d="M2.29162 8.85988C2.73501 7.49078 3.4634 6.23113 4.42882 5.16388C4.50861 5.0757 4.61281 5.01322 4.72819 4.98437C4.84356 4.95553 4.96491 4.96162 5.07682 5.00188L7.37842 5.82508C7.54227 5.88359 7.71688 5.90577 7.89016 5.89008C8.06343 5.8744 8.23122 5.82122 8.3819 5.73423C8.53258 5.64725 8.66254 5.52854 8.76278 5.38634C8.86302 5.24413 8.93114 5.08183 8.96242 4.91068L9.40042 2.50348C9.42163 2.3863 9.47723 2.27808 9.56014 2.1926C9.64306 2.10712 9.74953 2.04825 9.86602 2.02348C11.2722 1.72394 12.7258 1.72394 14.132 2.02348C14.2485 2.04825 14.355 2.10712 14.4379 2.1926C14.5208 2.27808 14.5764 2.3863 14.5976 2.50348L15.0368 4.91068C15.0681 5.08183 15.1362 5.24413 15.2364 5.38634C15.3367 5.52854 15.4666 5.64725 15.6173 5.73423C15.768 5.82122 15.9358 5.8744 16.1091 5.89008C16.2823 5.90577 16.457 5.88359 16.6208 5.82508L18.9236 5.00188C19.0355 4.96202 19.1566 4.95626 19.2718 4.98531C19.3869 5.01436 19.4909 5.07693 19.5704 5.16508C20.5353 6.23209 21.2632 7.4913 21.7064 8.85988C21.743 8.97293 21.7452 9.09429 21.7127 9.20858C21.6802 9.32288 21.6146 9.42495 21.524 9.50188L19.658 11.0859C19.5255 11.1985 19.419 11.3387 19.346 11.4965C19.2729 11.6544 19.2351 11.8263 19.2351 12.0003C19.2351 12.1742 19.2729 12.3461 19.346 12.504C19.419 12.6619 19.5255 12.802 19.658 12.9147L21.524 14.4987C21.6146 14.5756 21.6802 14.6777 21.7127 14.792C21.7452 14.9063 21.743 15.0276 21.7064 15.1407C21.2634 16.5097 20.5354 17.7693 19.5704 18.8367C19.4906 18.9249 19.3864 18.9873 19.271 19.0162C19.1557 19.045 19.0343 19.0389 18.9224 18.9987L16.6208 18.1755C16.457 18.117 16.2823 18.0948 16.1091 18.1105C15.9358 18.1262 15.768 18.1793 15.6173 18.2663C15.4666 18.3533 15.3367 18.472 15.2364 18.6142C15.1362 18.7564 15.0681 18.9187 15.0368 19.0899L14.5964 21.4983C14.5751 21.6151 14.5195 21.7229 14.4369 21.8082C14.3542 21.8934 14.2481 21.9522 14.132 21.9771C12.7258 22.2767 11.2722 22.2767 9.86602 21.9771C9.74953 21.9523 9.64306 21.8934 9.56014 21.808C9.47723 21.7225 9.42163 21.6143 9.40042 21.4971L8.96242 19.0899C8.93114 18.9187 8.86302 18.7564 8.76278 18.6142C8.66254 18.472 8.53258 18.3533 8.3819 18.2663C8.23122 18.1793 8.06343 18.1262 7.89016 18.1105C7.71688 18.0948 7.54227 18.117 7.37842 18.1755L5.07562 18.9987C4.96376 19.0385 4.84258 19.0443 4.72744 19.0152C4.61231 18.9862 4.50838 18.9236 4.42882 18.8355C3.46395 17.7685 2.73598 16.5093 2.29282 15.1407C2.25623 15.0276 2.25404 14.9063 2.28651 14.792C2.31899 14.6777 2.38466 14.5756 2.47522 14.4987L4.34122 12.9147C4.47377 12.802 4.58025 12.6619 4.65328 12.504C4.7263 12.3461 4.76412 12.1742 4.76412 12.0003C4.76412 11.8263 4.7263 11.6544 4.65328 11.4965C4.58025 11.3387 4.47377 11.1985 4.34122 11.0859L2.47522 9.50188C2.38466 9.42495 2.31899 9.32288 2.28651 9.20858C2.25404 9.09429 2.25623 8.97293 2.29282 8.85988H2.29162ZM3.56482 8.85268L5.11761 10.1703C5.38314 10.3956 5.59646 10.676 5.74276 10.992C5.88906 11.308 5.96484 11.652 5.96484 12.0003C5.96484 12.3485 5.88906 12.6926 5.74276 13.0086C5.59646 13.3246 5.38314 13.605 5.11761 13.8303L3.56482 15.1479C3.91522 16.0863 4.42162 16.9599 5.05882 17.7303L6.97401 17.0463C7.3018 16.9293 7.65112 16.8849 7.99774 16.9164C8.34436 16.9478 8.68 17.0543 8.98137 17.2284C9.28275 17.4025 9.54266 17.64 9.74307 17.9246C9.94349 18.2091 10.0796 18.5339 10.142 18.8763L10.508 20.8779C11.4952 21.0425 12.5028 21.0425 13.49 20.8779L13.856 18.8739C13.9186 18.5316 14.0548 18.207 14.2553 17.9226C14.4558 17.6382 14.7157 17.4007 15.017 17.2268C15.3184 17.0528 15.654 16.9464 16.0005 16.9151C16.3471 16.8837 16.6963 16.9281 17.024 17.0451L18.9404 17.7303C19.5788 16.9587 20.0837 16.0859 20.4344 15.1479L18.8816 13.8303C18.6157 13.6052 18.4021 13.3249 18.2555 13.0089C18.109 12.6928 18.0331 12.3486 18.0331 12.0003C18.0331 11.6519 18.109 11.3077 18.2555 10.9917C18.4021 10.6757 18.6157 10.3954 18.8816 10.1703L20.4344 8.85268C20.0838 7.91466 19.5788 7.04184 18.9404 6.27028L17.0252 6.95428C16.6975 7.0713 16.3483 7.11566 16.0017 7.08428C15.6552 7.05291 15.3196 6.94656 15.0182 6.77259C14.7169 6.59862 14.457 6.36121 14.2565 6.0768C14.056 5.79238 13.9198 5.46778 13.8572 5.12548L13.49 3.12268C12.5028 2.95809 11.4952 2.95809 10.508 3.12268L10.1432 5.12548C10.0808 5.46789 9.94469 5.79262 9.74427 6.07718C9.54386 6.36173 9.28395 6.59928 8.98257 6.77338C8.6812 6.94747 8.34556 7.05393 7.99894 7.08537C7.65232 7.11682 7.303 7.07249 6.97522 6.95548L5.05882 6.27028C4.42045 7.04185 3.9155 7.91467 3.56482 8.85268ZM8.99962 12.0003C8.99962 11.2046 9.31569 10.4416 9.87829 9.87896C10.4409 9.31635 11.204 9.00028 11.9996 9.00028C12.7953 9.00028 13.5583 9.31635 14.1209 9.87896C14.6835 10.4416 14.9996 11.2046 14.9996 12.0003C14.9996 12.7959 14.6835 13.559 14.1209 14.1216C13.5583 14.6842 12.7953 15.0003 11.9996 15.0003C11.204 15.0003 10.4409 14.6842 9.87829 14.1216C9.31569 13.559 8.99962 12.7959 8.99962 12.0003ZM10.1996 12.0003C10.1996 12.4777 10.3893 12.9355 10.7268 13.2731C11.0644 13.6106 11.5222 13.8003 11.9996 13.8003C12.477 13.8003 12.9348 13.6106 13.2724 13.2731C13.61 12.9355 13.7996 12.4777 13.7996 12.0003C13.7996 11.5229 13.61 11.0651 13.2724 10.7275C12.9348 10.3899 12.477 10.2003 11.9996 10.2003C11.5222 10.2003 11.0644 10.3899 10.7268 10.7275C10.3893 11.0651 10.1996 11.5229 10.1996 12.0003Z"/>
              </mask>
              <path
                d="M2.29162 8.85988C2.73501 7.49078 3.4634 6.23113 4.42882 5.16388C4.50861 5.0757 4.61281 5.01322 4.72819 4.98437C4.84356 4.95553 4.96491 4.96162 5.07682 5.00188L7.37842 5.82508C7.54227 5.88359 7.71688 5.90577 7.89016 5.89008C8.06343 5.8744 8.23122 5.82122 8.3819 5.73423C8.53258 5.64725 8.66254 5.52854 8.76278 5.38634C8.86302 5.24413 8.93114 5.08183 8.96242 4.91068L9.40042 2.50348C9.42163 2.3863 9.47723 2.27808 9.56014 2.1926C9.64306 2.10712 9.74953 2.04825 9.86602 2.02348C11.2722 1.72394 12.7258 1.72394 14.132 2.02348C14.2485 2.04825 14.355 2.10712 14.4379 2.1926C14.5208 2.27808 14.5764 2.3863 14.5976 2.50348L15.0368 4.91068C15.0681 5.08183 15.1362 5.24413 15.2364 5.38634C15.3367 5.52854 15.4666 5.64725 15.6173 5.73423C15.768 5.82122 15.9358 5.8744 16.1091 5.89008C16.2823 5.90577 16.457 5.88359 16.6208 5.82508L18.9236 5.00188C19.0355 4.96202 19.1566 4.95626 19.2718 4.98531C19.3869 5.01436 19.4909 5.07693 19.5704 5.16508C20.5353 6.23209 21.2632 7.4913 21.7064 8.85988C21.743 8.97293 21.7452 9.09429 21.7127 9.20858C21.6802 9.32288 21.6146 9.42495 21.524 9.50188L19.658 11.0859C19.5255 11.1985 19.419 11.3387 19.346 11.4965C19.2729 11.6544 19.2351 11.8263 19.2351 12.0003C19.2351 12.1742 19.2729 12.3461 19.346 12.504C19.419 12.6619 19.5255 12.802 19.658 12.9147L21.524 14.4987C21.6146 14.5756 21.6802 14.6777 21.7127 14.792C21.7452 14.9063 21.743 15.0276 21.7064 15.1407C21.2634 16.5097 20.5354 17.7693 19.5704 18.8367C19.4906 18.9249 19.3864 18.9873 19.271 19.0162C19.1557 19.045 19.0343 19.0389 18.9224 18.9987L16.6208 18.1755C16.457 18.117 16.2823 18.0948 16.1091 18.1105C15.9358 18.1262 15.768 18.1793 15.6173 18.2663C15.4666 18.3533 15.3367 18.472 15.2364 18.6142C15.1362 18.7564 15.0681 18.9187 15.0368 19.0899L14.5964 21.4983C14.5751 21.6151 14.5195 21.7229 14.4369 21.8082C14.3542 21.8934 14.2481 21.9522 14.132 21.9771C12.7258 22.2767 11.2722 22.2767 9.86602 21.9771C9.74953 21.9523 9.64306 21.8934 9.56014 21.808C9.47723 21.7225 9.42163 21.6143 9.40042 21.4971L8.96242 19.0899C8.93114 18.9187 8.86302 18.7564 8.76278 18.6142C8.66254 18.472 8.53258 18.3533 8.3819 18.2663C8.23122 18.1793 8.06343 18.1262 7.89016 18.1105C7.71688 18.0948 7.54227 18.117 7.37842 18.1755L5.07562 18.9987C4.96376 19.0385 4.84258 19.0443 4.72744 19.0152C4.61231 18.9862 4.50838 18.9236 4.42882 18.8355C3.46395 17.7685 2.73598 16.5093 2.29282 15.1407C2.25623 15.0276 2.25404 14.9063 2.28651 14.792C2.31899 14.6777 2.38466 14.5756 2.47522 14.4987L4.34122 12.9147C4.47377 12.802 4.58025 12.6619 4.65328 12.504C4.7263 12.3461 4.76412 12.1742 4.76412 12.0003C4.76412 11.8263 4.7263 11.6544 4.65328 11.4965C4.58025 11.3387 4.47377 11.1985 4.34122 11.0859L2.47522 9.50188C2.38466 9.42495 2.31899 9.32288 2.28651 9.20858C2.25404 9.09429 2.25623 8.97293 2.29282 8.85988H2.29162ZM3.56482 8.85268L5.11761 10.1703C5.38314 10.3956 5.59646 10.676 5.74276 10.992C5.88906 11.308 5.96484 11.652 5.96484 12.0003C5.96484 12.3485 5.88906 12.6926 5.74276 13.0086C5.59646 13.3246 5.38314 13.605 5.11761 13.8303L3.56482 15.1479C3.91522 16.0863 4.42162 16.9599 5.05882 17.7303L6.97401 17.0463C7.3018 16.9293 7.65112 16.8849 7.99774 16.9164C8.34436 16.9478 8.68 17.0543 8.98137 17.2284C9.28275 17.4025 9.54266 17.64 9.74307 17.9246C9.94349 18.2091 10.0796 18.5339 10.142 18.8763L10.508 20.8779C11.4952 21.0425 12.5028 21.0425 13.49 20.8779L13.856 18.8739C13.9186 18.5316 14.0548 18.207 14.2553 17.9226C14.4558 17.6382 14.7157 17.4007 15.017 17.2268C15.3184 17.0528 15.654 16.9464 16.0005 16.9151C16.3471 16.8837 16.6963 16.9281 17.024 17.0451L18.9404 17.7303C19.5788 16.9587 20.0837 16.0859 20.4344 15.1479L18.8816 13.8303C18.6157 13.6052 18.4021 13.3249 18.2555 13.0089C18.109 12.6928 18.0331 12.3486 18.0331 12.0003C18.0331 11.6519 18.109 11.3077 18.2555 10.9917C18.4021 10.6757 18.6157 10.3954 18.8816 10.1703L20.4344 8.85268C20.0838 7.91466 19.5788 7.04184 18.9404 6.27028L17.0252 6.95428C16.6975 7.0713 16.3483 7.11566 16.0017 7.08428C15.6552 7.05291 15.3196 6.94656 15.0182 6.77259C14.7169 6.59862 14.457 6.36121 14.2565 6.0768C14.056 5.79238 13.9198 5.46778 13.8572 5.12548L13.49 3.12268C12.5028 2.95809 11.4952 2.95809 10.508 3.12268L10.1432 5.12548C10.0808 5.46789 9.94469 5.79262 9.74427 6.07718C9.54386 6.36173 9.28395 6.59928 8.98257 6.77338C8.6812 6.94747 8.34556 7.05393 7.99894 7.08537C7.65232 7.11682 7.303 7.07249 6.97522 6.95548L5.05882 6.27028C4.42045 7.04185 3.9155 7.91467 3.56482 8.85268ZM8.99962 12.0003C8.99962 11.2046 9.31569 10.4416 9.87829 9.87896C10.4409 9.31635 11.204 9.00028 11.9996 9.00028C12.7953 9.00028 13.5583 9.31635 14.1209 9.87896C14.6835 10.4416 14.9996 11.2046 14.9996 12.0003C14.9996 12.7959 14.6835 13.559 14.1209 14.1216C13.5583 14.6842 12.7953 15.0003 11.9996 15.0003C11.204 15.0003 10.4409 14.6842 9.87829 14.1216C9.31569 13.559 8.99962 12.7959 8.99962 12.0003ZM10.1996 12.0003C10.1996 12.4777 10.3893 12.9355 10.7268 13.2731C11.0644 13.6106 11.5222 13.8003 11.9996 13.8003C12.477 13.8003 12.9348 13.6106 13.2724 13.2731C13.61 12.9355 13.7996 12.4777 13.7996 12.0003C13.7996 11.5229 13.61 11.0651 13.2724 10.7275C12.9348 10.3899 12.477 10.2003 11.9996 10.2003C11.5222 10.2003 11.0644 10.3899 10.7268 10.7275C10.3893 11.0651 10.1996 11.5229 10.1996 12.0003Z"
                fill="#E1EBF8" stroke="#E1EBF8" stroke-width="2" mask="url(#path-1-inside-1_1733_6915)"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
    <table class="main-table">
      <thead v-if="type == 'rows'">
      <draggable v-model="headers" tag="tr" @change="saveSettings">
        <template v-for="header in headers">
          <td class="sortable" @click="set_sort(header.key)" :key="header.key" scope="col"
              v-if="showHeaders[header.key]">
            {{ $vuetify.lang.t('$vuetify.' + header.name) }}
            <v-icon class="sorts__icon" v-if="sort.includes(header.key)" :class="{reverse: sort[0] == '-'}">
              mdi-arrow-up
            </v-icon>
          </td>
        </template>
      </draggable>
      </thead>
      <tbody :class="{ 'cards ': type == 'cards' }">
      <GarageCard v-for="(car) in cars" :key="car.id" :id="car.id" :photo="car.photo"
                  :options="car.options" :type="type" :active="car.active" :organization="car.organization"
                  :headers="headers"
                  @edit="
            (id) => {
              car_action = 'edit';
              chosen_id = id;
              car_create_open();
            }"
                  @archive=" ()=> {loadData()}">
      </GarageCard>
      </tbody>
    </table>
    <div class="page-footer">
      <per-page-select v-model="perPage"></per-page-select>
      <v-pagination
        v-model="page"
        :length="length"
        @input="loadData"
      ></v-pagination>
    </div>

    <v-dialog v-model="car_create_modal">
      <div class="modal modal-big">
        <div class="h1">
          <span v-if="car_action == 'add'"> {{ $vuetify.lang.t('$vuetify.add') }}</span>
          <span v-if="car_action == 'edit'"> {{ $vuetify.lang.t('$vuetify.edit') }}</span>
        </div>
        <v-form ref="form" class="" v-if="car_create_step == 1" :key="1" @submit.prevent="check">
          <div class="h2">Основная информация</div>
          <v-checkbox v-if="permissions.admin" v-model="newCar.organization" :value="currentOrganization"
                      :label="$vuetify.lang.t('$vuetify.organizationCar')"></v-checkbox>
          <v-text-field :label="$vuetify.lang.t('$vuetify.name2')" v-model="newCar.name" outlined
                        :rules="[$rules.required]"></v-text-field>
          <v-text-field :label="$vuetify.lang.t('$vuetify.typeBody')" v-model="newCar.type_body"
                        outlined></v-text-field>
          <v-text-field :label="$vuetify.lang.t('$vuetify.odometer')" v-model="newCar.odometer" outlined>
          </v-text-field>
          <v-text-field type="number" :label="$vuetify.lang.t('$vuetify.accounting.card.price')" v-model="newCar.cost"
                        outlined :rules="[$rules.nullPositiveNumbers]"></v-text-field>
          <div class="h2">{{ $vuetify.lang.t('$vuetify.regData') }}</div>
          <div class="form__row">
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="newCar.registration ? new Date(newCar.registration).toLocaleDateString('ru-Ru') : ''"
                  :label="$vuetify.lang.t('$vuetify.registration')"
                  append-icon="$calendar"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  :rules="[$rules.required]"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="newCar.registration"
                no-title first-day-of-week="1" show-week locale-first-day-of-year="4" show-adjacent-months
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
            <v-text-field :label="$vuetify.lang.t('$vuetify.regNumber')" v-model="newCar.reg_number" outlined
                          :rules="[$rules.required]">
            </v-text-field>
          </div>
          <v-text-field :label="$vuetify.lang.t('$vuetify.vin')" v-model="newCar.vin" outlined
                        :rules="[$rules.required]"></v-text-field>
          <div class="sign-up__buttons btn-group">
            <div class="btn btn-secondary" @click="car_create_close">
              {{ $vuetify.lang.t('$vuetify.cancel') }}
            </div>
            <button class="btn btn-primary">{{ $vuetify.lang.t('$vuetify.forward') }}</button>
          </div>
        </v-form>
        <v-form ref="form" class="" v-if="car_create_step == 2" :key="2" @submit.prevent="check">
          <div class="h2">{{ $vuetify.lang.t('$vuetify.carTechnic') }}</div>
          <div class="form__row">
            <v-text-field v-model="newCar.engine"
                          :label="$vuetify.lang.t('$vuetify.engine')" outlined></v-text-field>
            <v-text-field v-model="newCar.fuel"
                          :label="$vuetify.lang.t('$vuetify.fuel')" outlined></v-text-field>
          </div>
          <div class="form__row">
            <v-text-field v-model="newCar.type_drive"
                          :label="$vuetify.lang.t('$vuetify.typeDrive')" outlined></v-text-field>
            <v-text-field v-model="newCar.transmission"
                          :label="$vuetify.lang.t('$vuetify.transmission')" outlined></v-text-field>
          </div>
          <div class="h2">{{ $vuetify.lang.t('$vuetify.carView') }}</div>
          <v-text-field v-model="newCar.color"
                        :label="$vuetify.lang.t('$vuetify.color')" outlined></v-text-field>
          <div v-if="car_action == 'edit'">
            <div class="flex justify-between" v-for="(doc, i) in newCar.photo" :key="doc">
                <span class="filename">
                  {{
                    doc.substr(doc.lastIndexOf('/') + 1, doc.lastIndexOf('_') + 1) + doc.substr(doc.lastIndexOf('.'))
                  }}
                </span>
              <button class="btn-icon" @click="deletePhoto(i)">
                <delete-icon/>
              </button>
            </div>
          </div>
          <v-file-input class="file-input" v-model="photo"
                        accept=".jpg, .png, .jpeg" prepend-icon="$photo"
                        :placeholder="$vuetify.lang.t('$vuetify.uploadImg')"
                        :rules="[$rules.multipleFileSize]" multiple>
          </v-file-input>
          <div class="sign-up__buttons btn-group">
            <div class="btn btn-secondary" @click="car_create_step--">
              {{ $vuetify.lang.t('$vuetify.back') }}
            </div>
            <button class="btn btn-primary">{{ $vuetify.lang.t('$vuetify.forward') }}</button>
          </div>
        </v-form>
        <v-form ref="form" class="" v-if="car_create_step == 3" :key="3" @submit.prevent="">
          <v-textarea :label="$vuetify.lang.t('$vuetify.characteristics')" v-model=" newCar.characteristics"
                      outlined></v-textarea>
          <div class="h2">{{ $vuetify.lang.t('$vuetify.carDocuments') }}</div>
          <div v-for="(doc, i) in documents" :key="i">
            <div class="form__row">
              <v-text-field v-model="doc.name"
                            :label="$vuetify.lang.t('$vuetify.name2')" outlined></v-text-field>
              <v-btn icon @click="deleteDoc(i)">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <v-file-input class="file-input" v-model="doc.file"
                          accept=".jpg, .png, .jpeg" prepend-icon="$photo"
                          :placeholder="$vuetify.lang.t('$vuetify.downloadDocument')"
                          :rules="[$rules.fileSize]">
            </v-file-input>
          </div>
          <button class="btn btn-secondary mb-20" @click="addDocument">
            {{ $vuetify.lang.t('$vuetify.addDocument') }}
          </button>
          <v-progress-linear :class="{form__progress : form_loader}"
                             :active="form_loader"
                             indeterminate
                             rounded
                             height="6"
          ></v-progress-linear>
          <div class="error--text" v-if="alertError">{{ alertMsg }}</div>
          <div class="sign-up__buttons btn-group">
            <div class="btn btn-secondary" @click="car_create_step--">
              {{ $vuetify.lang.t('$vuetify.back') }}
            </div>
            <button class="btn btn-primary" @click="uploadFile">
              <span v-if="car_action == 'add'">{{ $vuetify.lang.t('$vuetify.add') }}</span>
              <span v-if="car_action == 'edit'">{{ $vuetify.lang.t('$vuetify.edit') }}</span>
            </button>
          </div>
        </v-form>
      </div>
    </v-dialog>

    <SpinnerLoader :overlay="loader"></SpinnerLoader>

    <v-dialog v-model="settingsModal">
      <div class="modal">
        <div class="h1">
          {{ $vuetify.lang.t("$vuetify.selectShownHeaders") }}
        </div>
        <v-form ref="form" @submit.prevent="">
          <v-checkbox v-for="header in headers" v-model="showHeaders[header.key]" :key="header.key"
                      :label="$vuetify.lang.t('$vuetify.' + header.name)"></v-checkbox>
          <div class="error--text" v-if="alertError">{{ alertMsg }}</div>
          <div class="sign-up__buttons btn-group">
            <button class="btn btn-secondary" @click="settingsModal=false">
              {{ $vuetify.lang.t('$vuetify.cancel') }}
            </button>
            <button class="btn btn-primary" @click="saveSettings">
              {{ $vuetify.lang.t('$vuetify.save') }}
            </button>
          </div>
        </v-form>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import SpinnerLoader from "@/components/SpinnerLoader";
import GarageCard from "@/views/parts/GarageCard";
import DeleteIcon from "@/components/icons/DeleteIcon";
import draggable from "vuedraggable";
import PerPageSelect from "@/components/PerPageSelect.vue";
import {mapActions, mapGetters} from "vuex";

class Option {
  constructor(value, name = "unnamed", icon = "") {
    this.value = value;
    this.name = name;
    this.icon = icon;
  }
}

export default {
  name: "GarageList",
  components: {
    PerPageSelect,
    DeleteIcon,
    GarageCard,
    SpinnerLoader,
    draggable,
  },

  watch: {
    type: function () {
      localStorage.setItem("type_cars", this.type);
    },
    sort: function () {
      this.loadData()
    },
    arch: function () {
      this.loadData()
    },
    perPage: function () {
      if ((this.page * this.perPage) > (this.page * this.cars.length))
        this.page = 1
      this.loadData()
    },

    loadedFiles: function (val) {
      let count = this.documents.length + this.photo.length
      if (val == count && val != 0) {
        this.confirmCar()
      }
    },
  },

  data: function () {
    return {
      type: localStorage.getItem("type_cars") ?? (window.screen.width < 600 ? "cards" : "cards"),
      arch: false,
      sort: 'name',
      search: '',
      filter: 'user_profile',
      page: 1,
      perPage: Number(localStorage.getItem("per_page") ?? 24),
      length: 0,
      selectSorts: [
        {
          name: this.$vuetify.lang.t('$vuetify.sorts.byName') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
          value: 'name'
        },
        {
          name: this.$vuetify.lang.t('$vuetify.sorts.byName') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
          value: '-name'
        },
        {
          name: this.$vuetify.lang.t('$vuetify.sorts.byRegDate') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
          value: 'registration'
        },
        {
          name: this.$vuetify.lang.t('$vuetify.sorts.byRegDate') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
          value: '-registration'
        },
        {
          name: this.$vuetify.lang.t('$vuetify.sorts.byRegNumber') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
          value: 'reg_number'
        },
        {
          name: this.$vuetify.lang.t('$vuetify.sorts.byRegNumber') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
          value: '-reg_number'
        },
      ],
      selectFilter: [
        {
          name: this.$vuetify.lang.t('$vuetify.dataFooter.itemsPerPageAll'),
          value: null
        },
        {
          name: this.$vuetify.lang.t('$vuetify.personal'),
          value: 'user_profile'
        },
        {
          name: this.$vuetify.lang.t('$vuetify.fromOrganization'),
          value: 'organization'
        },
      ],
      headers: [
        {key: "name", name: 'name'},
        {key: "type_body", name: 'typeBody'},
        {key: "reg_number", name: 'regNumber'},
        {key: "vin", name: 'vin'},
      ],

      tmp: false,

      chosen_id: "",
      car_action: "add",
      car_create_modal: false,
      car_create_step: 1,
      row_cars: [],

      cars: [],

      newCar: {},
      photo: [],
      documents: [],
      deleted: [],
      menu1: false,
      loadedFiles: 0,
      currentOrganization: JSON.parse(localStorage.getItem('organization')).id,

      alertMsg: "",
      alertError: false,
      loader: false,
      form_loader: false,

      settingsModal: false,
      tableSettings: {},
      showHeaders: {},
    };
  },

  created: function () {
    this.checkPermission('Гараж').then(()=>{

      this.loadData();
      this.loadSettings();
    });
  },

  methods: {
    ...mapActions(['checkPermission']),

    loadData: function () {
      this.loader = true
      this.$axios({
        url: this.$hostname + "time-tracking/garage",
        method: "get",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
        params: {
          arch: !this.arch,
          sort: this.sort,
          search: this.search,
          filter: this.filter,
          page: this.page,
          per: this.perPage,
        }
      }).then((response) => {
        if (response.data.data.data) {
          this.length = response.data.data.pages
          this.cars = [];
          this.row_cars = response.data.data.data;
          response.data.data.data.forEach((element) => {

            this.cars.push({
              id: element.id,
              photo: JSON.parse(element.photo).length > 0 ? JSON.parse(element.photo)[0] : null,
              active: element.active,
              organization: element.organization,
              options: {
                array: [
                  new Option(element.name),
                  new Option(element.type_body),
                  new Option(
                    element.reg_number,
                    "regNumber",
                    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 50 50"><path style="line-height:normal;text-indent:0;text-align:start;text-decoration-line:none;text-decoration-style:solid;text-decoration-color:#000;text-transform:none;block-progression:tb;isolation:auto;mix-blend-mode:normal" d="M 23.857422 2 C 22.749479 2 22 2.9821212 22 4 L 22 7.9902344 L 14.068359 7.9902344 C 11.832946 7.9902344 10 9.8242551 10 12.058594 L 10 43.921875 C 10 46.157288 11.834021 47.990234 14.068359 47.990234 L 37.921875 47.990234 C 40.157288 47.990234 41.990234 46.156213 41.990234 43.921875 L 41.990234 12.060547 L 41.990234 12.058594 C 41.990464 9.8237651 40.157503 7.9902344 37.923828 7.9902344 L 30 7.9902344 L 30 4 C 30 2.9821212 29.250521 2 28.142578 2 L 23.857422 2 z M 24 4 L 28 4 L 28 12 L 24 12 L 24 8.9902344 L 24 4 z M 14.068359 9.9902344 L 22 9.9902344 L 22 12 C 22 13.017879 22.749479 14 23.857422 14 L 28.142578 14 C 29.250521 14 30 13.017879 30 12 L 30 9.9902344 L 37.923828 9.9902344 C 39.07749 9.9902344 39.990915 10.904325 39.990234 12.058594 L 39.990234 43.921875 C 39.990234 45.075537 39.076462 45.990234 37.921875 45.990234 L 14.068359 45.990234 C 12.914698 45.990234 12 45.076462 12 43.921875 L 12 12.058594 C 12 10.904932 12.913772 9.9902344 14.068359 9.9902344 z M 23 17 C 22.348333 17 21.747335 17.14149 21.234375 17.40625 C 20.721415 17.67101 20.257242 18.063884 20.050781 18.685547 L 19 21.837891 L 19 22 L 18 22 L 18 24 L 19 24 L 19 28.667969 L 19 29.332031 C 19 29.700031 19.224 30 19.5 30 L 21.5 30 C 21.776 30 22 29.700031 22 29.332031 L 22 28.667969 L 30 28.667969 L 30 29.332031 C 30 29.700031 30.224 30 30.5 30 L 32.5 30 C 32.776 30 33 29.700031 33 29.332031 L 33 27.332031 L 33 24 L 34 24 L 34 22 L 33 22 L 33 21.837891 L 31.949219 18.685547 C 31.742758 18.063884 31.278585 17.67101 30.765625 17.40625 C 30.252665 17.14149 29.651667 17 29 17 L 23 17 z M 23 19 L 29 19 C 29.348333 19 29.655867 19.0846 29.847656 19.183594 C 30.028133 19.276744 30.069478 19.372531 30.052734 19.320312 L 30.945312 22 L 21.054688 22 L 21.947266 19.320312 C 21.930522 19.372529 21.971863 19.276744 22.152344 19.183594 C 22.344133 19.08465 22.651667 19 23 19 z M 22 24 C 22.552 24 23 24.448 23 25 C 23 25.552 22.552 26 22 26 C 21.448 26 21 25.552 21 25 C 21 24.448 21.448 24 22 24 z M 30 24 C 30.552 24 31 24.448 31 25 C 31 25.552 30.552 26 30 26 C 29.448 26 29 25.552 29 25 C 29 24.448 29.448 24 30 24 z M 17 34 A 1.0001 1.0001 0 1 0 17 36 L 35 36 A 1.0001 1.0001 0 1 0 35 34 L 17 34 z M 17 38 A 1.0001 1.0001 0 1 0 17 40 L 35 40 A 1.0001 1.0001 0 1 0 35 38 L 17 38 z" font-weight="400" font-family="sans-serif" white-space="normal" overflow="visible"/></svg>'
                  ),
                  new Option(
                    element.vin,
                    "vin",
                    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 50 50"><path style="line-height:normal;text-indent:0;text-align:start;text-decoration-line:none;text-decoration-style:solid;text-decoration-color:#000;text-transform:none;block-progression:tb;isolation:auto;mix-blend-mode:normal" d="M 23.857422 2 C 22.749479 2 22 2.9821212 22 4 L 22 7.9902344 L 14.068359 7.9902344 C 11.832946 7.9902344 10 9.8242551 10 12.058594 L 10 43.921875 C 10 46.157288 11.834021 47.990234 14.068359 47.990234 L 37.921875 47.990234 C 40.157288 47.990234 41.990234 46.156213 41.990234 43.921875 L 41.990234 12.060547 L 41.990234 12.058594 C 41.990464 9.8237651 40.157503 7.9902344 37.923828 7.9902344 L 30 7.9902344 L 30 4 C 30 2.9821212 29.250521 2 28.142578 2 L 23.857422 2 z M 24 4 L 28 4 L 28 12 L 24 12 L 24 8.9902344 L 24 4 z M 14.068359 9.9902344 L 22 9.9902344 L 22 12 C 22 13.017879 22.749479 14 23.857422 14 L 28.142578 14 C 29.250521 14 30 13.017879 30 12 L 30 9.9902344 L 37.923828 9.9902344 C 39.07749 9.9902344 39.990915 10.904325 39.990234 12.058594 L 39.990234 43.921875 C 39.990234 45.075537 39.076462 45.990234 37.921875 45.990234 L 14.068359 45.990234 C 12.914698 45.990234 12 45.076462 12 43.921875 L 12 12.058594 C 12 10.904932 12.913772 9.9902344 14.068359 9.9902344 z M 23 17 C 22.348333 17 21.747335 17.14149 21.234375 17.40625 C 20.721415 17.67101 20.257242 18.063884 20.050781 18.685547 L 19 21.837891 L 19 22 L 18 22 L 18 24 L 19 24 L 19 28.667969 L 19 29.332031 C 19 29.700031 19.224 30 19.5 30 L 21.5 30 C 21.776 30 22 29.700031 22 29.332031 L 22 28.667969 L 30 28.667969 L 30 29.332031 C 30 29.700031 30.224 30 30.5 30 L 32.5 30 C 32.776 30 33 29.700031 33 29.332031 L 33 27.332031 L 33 24 L 34 24 L 34 22 L 33 22 L 33 21.837891 L 31.949219 18.685547 C 31.742758 18.063884 31.278585 17.67101 30.765625 17.40625 C 30.252665 17.14149 29.651667 17 29 17 L 23 17 z M 23 19 L 29 19 C 29.348333 19 29.655867 19.0846 29.847656 19.183594 C 30.028133 19.276744 30.069478 19.372531 30.052734 19.320312 L 30.945312 22 L 21.054688 22 L 21.947266 19.320312 C 21.930522 19.372529 21.971863 19.276744 22.152344 19.183594 C 22.344133 19.08465 22.651667 19 23 19 z M 22 24 C 22.552 24 23 24.448 23 25 C 23 25.552 22.552 26 22 26 C 21.448 26 21 25.552 21 25 C 21 24.448 21.448 24 22 24 z M 30 24 C 30.552 24 31 24.448 31 25 C 31 25.552 30.552 26 30 26 C 29.448 26 29 25.552 29 25 C 29 24.448 29.448 24 30 24 z M 17 34 A 1.0001 1.0001 0 1 0 17 36 L 35 36 A 1.0001 1.0001 0 1 0 35 34 L 17 34 z M 17 38 A 1.0001 1.0001 0 1 0 17 40 L 35 40 A 1.0001 1.0001 0 1 0 35 38 L 17 38 z" font-weight="400" font-family="sans-serif" white-space="normal" overflow="visible"/></svg>'
                  ),
                ],
                name: element.name,
                type_body: element.type_body,
                reg_number: element.reg_number,
                vin: element.vin,
              }
            });
          });
        }
      }).catch((err) => {
        this.alertMsg = this.$catch(err);
        this.alertError = true;
      }).then(() => {
        this.loader = false
      })
    },
    loadSettings() {
      this.$axios({
        url: this.$hostname + "time-tracking/user-settings/table-settings",
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      }).then((response) => {
        this.tableSettings = response.data.data.data
        if (response.data.data.data && response.data.data.data.garage) {
          this.showHeaders = response.data.data.data.garage
        } else
          this.showHeaders = {
            name: true,
            type_body: true,
            reg_number: true,
            vin: true,
          }

        let order = []
        this.headers.forEach(header => {
          order.splice(this.showHeaders.order.indexOf(header.key), 0, header)
        })
        this.headers = order
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },

    confirmCar() {
      if (this.$refs.form.validate()) {
        this.form_loader = true
        if (this.car_action == "add") {
          this.addCar();
        } else {
          this.editCar();
        }
      } else {
        this.alertMsg = "Заполните все необходимые данные";
        this.alertError = true;
      }
    },

    uploadFile() {
      if (this.$refs.form.validate()) {
        this.form_loader = true
        if (this.documents.length == 0 && this.photo.length == 0)
          this.confirmCar()
        this.documents.forEach(doc => {
          if (doc.file) {
            this.$axios({
              url: this.$hostname + "time-tracking/images/upload/garage",
              method: "POST",
              headers: {
                "Content-Type": "multipart/form-data",
              },
              data: {
                file: doc.file,
              },
            }).then((response) => {
              if (this.car_action == 'edit') {
                doc.name = (doc.name.length > 0 ? doc.name : doc.file.name)
                doc.path = response.data.data
              } else
                this.newCar.documents.push({
                  path: response.data.data,
                  name: (doc.name.length > 0 ? doc.name : doc.file.name)
                })

              this.loadedFiles += 1
            }).catch((error) => {
              alert("Ошибка загрузки файла: " + error.message);
            });
          } else {
            this.loadedFiles += 1
          }
        })
        this.photo.forEach(doc => {
          this.$axios({
            url: this.$hostname + "time-tracking/images/upload/garage",
            method: "POST",
            headers: {
              "Content-Type": "multipart/form-data",
            },
            data: {
              file: doc,
            },
          }).then((response) => {
            this.newCar.photo.push(response.data.data)
            this.loadedFiles += 1
          }).catch((error) => {
            alert("Ошибка загрузки файла: " + error.message);
          });
        })
      } else {
        this.alertMsg = "Заполните все необходимые данные";
        this.alertError = true;
      }
    },
    addCar() {
      this.newCar.path = JSON.stringify(this.newCar.path)
      this.newCar.documents = JSON.stringify(this.newCar.documents)
      this.newCar.photo = JSON.stringify(this.newCar.photo)
      if (!this.newCar.organization){
        this.newCar.user_profile = this.$parent.user.id
      } else {
        this.newCar.user_profile = null
      }
      this.$axios
        .post(
          this.$hostname + "time-tracking/garage",
          this.newCar,
          {
            headers: {
              Authorization:
                "Token " +
                (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
              "Content-Type": "multipart/form-data",
            },
          }
        ).then(() => {
        this.car_create_close();
        this.loadData();
      }).catch((response) => {
        this.alertMsg = this.$catch(response);
        this.alertError = true;
      }).then(() => {
        this.form_loader = false
      })
    },

    editCar() {
      this.$axios
        .put(
          this.$hostname + "time-tracking/garage",
          {
            id: this.newCar.id,
            name: this.newCar.name,
            type_body: this.newCar.type_body,
            registration: this.newCar.registration,
            engine: this.newCar.engine,
            fuel: this.newCar.fuel,
            odometer: this.newCar.odometer,
            type_drive: this.newCar.type_drive,
            transmission: this.newCar.transmission,
            color: this.newCar.color,
            reg_number: this.newCar.reg_number,
            vin: this.newCar.vin,
            cost: this.newCar.cost,
            active: this.newCar.active,
            characteristics: this.newCar.characteristics,
            photo: JSON.stringify(this.newCar.photo),
            path: JSON.stringify(this.newCar.path),
            documents: JSON.stringify(this.newCar.documents),
            deleted: JSON.stringify(this.deleted),
            user_profile: this.newCar.organization ? null : this.$parent.user.id,
            organization: this.newCar.organization ? this.currentOrganization : null,
          },
          {
            headers: {
              Authorization:
                "Token " +
                (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
              "Content-Type": "multipart/form-data",
            },
          }
        ).then(() => {
        this.car_create_close();
        this.loadData();
      }).catch((response) => {
        this.alertMsg = this.$catch(response);
        this.alertError = true;
      }).then(() => {
        this.form_loader = false
      })
    },

    car_create_open() {
      this.car_create_step = 1;
      this.car_create_modal = true;

      if (this.car_action == "edit") {
        let tmp_car = this.row_cars.filter((c) => {
          return c.id == this.chosen_id;
        })[0];
        this.loadedFiles = 0
        this.newCar = {
          id: tmp_car.id,
          name: tmp_car.name,
          type_body: tmp_car.type_body,
          registration: tmp_car.registration,
          engine: tmp_car.engine,
          fuel: tmp_car.fuel,
          odometer: tmp_car.odometer,
          type_drive: tmp_car.type_drive,
          transmission: tmp_car.transmission,
          color: tmp_car.color,
          reg_number: tmp_car.reg_number,
          vin: tmp_car.vin,
          cost: tmp_car.cost,
          active: tmp_car.active,
          photo: JSON.parse(tmp_car.photo),
          path: JSON.parse(tmp_car.path),
          documents: tmp_car.documents,
          organization: tmp_car.organization,
        }
        this.photo = []
        this.documents = tmp_car.documents
        this.deleted = []
        this.alertError = false
        this.form_loader = false
      } else {
        this.alertError = false
        this.form_loader = false
        this.newCar = {
          photo: [],
          path: [],
          documents: [],
          active: true,
        }
        this.documents = []
        this.photo = []
        this.loadedFiles = 0
      }
    },

    addDocument() {
      this.documents.push({name: "", file: null, path: ""})
    },

    deleteDoc(i) {
      if (this.documents[i].id) {
        this.deleted.push(this.documents[i])
      }
      this.documents.splice(i, 1)
    },
    deletePhoto(i) {
      this.deleted.push(this.newCar.photo[i])
      this.newCar.photo.splice(i, 1)
    },

    car_create_close() {
      this.car_create_modal = false;
    },

    check() {
      if (this.$refs.form.validate()) {
        this.car_create_step++;
      }
    },

    saveSettings() {
      let order = []
      this.headers.forEach(header => {
        order.push(header.key)
      })
      this.showHeaders.order = order
      this.tableSettings.garage = this.showHeaders
      this.$axios({
        url: this.$hostname + "time-tracking/user-settings/table-settings",
        method: "PUT",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          table_settings: JSON.stringify(this.tableSettings)
        }
      }).then(() => {
        this.settingsModal = false
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },

    set_sort(field) {
      if (this.sort.includes(field) && this.sort[0] != '-') {
        this.sort = '-' + field
      } else {
        this.sort = field
      }
    },
  },

  computed: {
    ...mapGetters(['permissions'])
  }
}
</script>

<style scoped>

</style>